import { TypeInteraction, RequestResult } from "domain/entities/type-interaction";
import { TypeInteractionRepository } from "domain/repositories";

export default class CreateUseCase {
    private typeInteractionRepository: TypeInteractionRepository;
    
    public constructor(typeInteractionRepository: TypeInteractionRepository) {
        this.typeInteractionRepository = typeInteractionRepository
    }

    public async createTypeInteraction(typeInteraction: TypeInteraction, token: Promise<[string | null, string | null]>): Promise<[RequestResult, null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.typeInteractionRepository.createTypeInteraction(typeInteraction, t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}